import ADMIN from "./ADMIN";
import OBSERVER from "./OBSERVER";
import PM from "./PM";
import PROFESSOR from "./PROFESSOR";
import STUDENT from "./STUDENT";

export default { ADMIN, OBSERVER, PM, PROFESSOR, STUDENT };
